module.exports = __webpack_public_path__ + "static/tiffany-06-ccdc53cf3a0aa69602bcb8b52ee29129.png";